import { BaseComponent } from '../components/BaseComponent';

type ComponentClass<T = {}> = typeof BaseComponent & { prototype: T };

class ComponentUtil {
  public static loader = <T>(
    cond: boolean,
    factory: () => Promise<{ default: T }>,
    cb: (ctor: T) => void,
  ) => {
    if (cond) {
      factory().then(({ default: Component }) => cb(Component));
    }
  }

  public static binder = <T extends BaseComponent>(
    hook: string,
    Component: ComponentClass<T>,
  ) => {
    const targets = document.querySelectorAll<HTMLElement>(hook);
    const instances = targets.forEach(x => new Component(x));

    return instances;
  }
}

export { ComponentUtil };
